// extracted by mini-css-extract-plugin
export var clear = "headerDesktop-module--clear--0673d";
export var icon = "headerDesktop-module--icon--64a8f";
export var iconContainer = "headerDesktop-module--iconContainer--d8f17";
export var menuIcon = "headerDesktop-module--menuIcon--02c98";
export var searchContainer = "headerDesktop-module--searchContainer--e697b";
export var searchForm = "headerDesktop-module--searchForm--740cf";
export var underlined = "headerDesktop-module--underlined--42d6d";
export var wrapper = "headerDesktop-module--wrapper--adad5";